import { useEffect, useRef } from "react";
import { Formik, Form as FormikForm } from "formik";

import { useAuth } from "../../../../../hooks/useAuth";
import { useCountdown } from "../../../../../hooks/useCountdown";

import Text from "../../../../../shared/components/Text";
import Input from "../../../../../shared/components/Input";
import Countdown from "../../../../../shared/components/CountDown";

import { theme } from "../../../../../styles/theme";

import { Box, Button, Grid, Typography } from "@mui/material";
import MuiCircularProgress from "@mui/material/CircularProgress";

export const SecurityCodeForm = ({
  initialValues,
  onSubmit,
  enteredCode,
  onChangeVerificationCode,
  onResendCodeVerification,
}) => {
  const {
    twoFactorAuthData,
    handleLogout,
    isVerificationCodeSubmitting,
    resendAmount,
  } = useAuth();

  const { hasTimeExpired } = useCountdown();

  const hasEmptyInput = Object.values(enteredCode).some(
    (value) => value === ""
  );

  const disabledCodeInput = !hasEmptyInput || hasTimeExpired;

  const formRef = useRef(null);

  useEffect(() => {
    if (!hasEmptyInput) {
      formRef.current.submitForm();
    }
  }, [hasEmptyInput]);

  return (
    <Formik
      enableReinitialize
      initialValues={initialValues}
      onSubmit={() => onSubmit(formRef.current)}
      innerRef={formRef}
    >
      {({ isSubmitting, setSubmitting }) => (
        <FormikForm noValidate fullWidth>
          <Text textAlign="center" color={theme.palette.gray.main}>
            Nós enviamos o código de verificação para <br></br>
            {twoFactorAuthData[
              twoFactorAuthData.selectedContactType
            ].toLowerCase()}
          </Text>

          <Box
            display="flex"
            justifyContent="center"
            alignItems="center"
            gap={3}
            marginTop={5}
          >
            {Object.keys(enteredCode).map((_, index) => (
              <Grid item xs={1} key={index}>
                <Input
                  type="number"
                  autoFocus={index === 0}
                  disabled={disabledCodeInput || isSubmitting}
                  id={`input-${index}`}
                  value={enteredCode[index] || ""}
                  onChange={(e) =>
                    onChangeVerificationCode(index, e.target.value)
                  }
                  inputProps={{
                    maxLength: 1,
                    style: {
                      textAlign: "center",
                      width: "20px",
                      height: "28px",
                      fontSize: "22px",
                    },
                  }}
                />
              </Grid>
            ))}
          </Box>

          <Countdown />

          <Box
            mt={4}
            display="flex"
            justifyContent="center"
            flexDirection="column"
            gap="14px"
          >
            {isSubmitting && isVerificationCodeSubmitting ? (
              <Box
                display="flex"
                alignItems="center"
                justifyContent="center"
                width="100%"
              >
                <Typography
                  display="flex"
                  alignItems="center"
                  flexDirection="column"
                  gap={1}
                  fontSize="16px"
                  color={theme.palette.primary.main}
                >
                  Verificando o código informado...{" "}
                  <MuiCircularProgress size={20} />
                </Typography>
              </Box>
            ) : (
              <Button
                fullWidth
                disabled={!resendAmount || isSubmitting}
                type="button"
                onClick={() => onResendCodeVerification(setSubmitting)}
                sx={{
                  backgroundColor: `${theme.palette.primary.main}`,
                  color: `${theme.palette.common.white}`,
                  height: 50,
                  fontSize: 16,
                  width: "100%",
                  "&:hover": {
                    backgroundColor: `${theme.palette.primary.light}`,
                  },
                  "& svg": {
                    color: `${theme.palette.common.white}`,
                  },
                }}
              >
                {isSubmitting && !isVerificationCodeSubmitting ? (
                  <MuiCircularProgress size={30} />
                ) : (
                  "REENVIAR CÓDIGO"
                )}
              </Button>
            )}
            <Button
              disableRipple
              disabled={isSubmitting}
              sx={{
                backgroundColor: "transparent",
                border: "none",
                padding: "0px",
                cursor: "pointer",
                fontSize: "16px",
                textTransform: "inherit",
                transition: "opacity 0.2s",
                "&:hover": {
                  backgroundColor: "transparent",
                  border: "none",
                  opacity: 0.9,
                },
              }}
              onClick={handleLogout}
            >
              Voltar para tela de login
            </Button>
          </Box>
        </FormikForm>
      )}
    </Formik>
  );
};
